import { InertiaSharedData } from '@/types';
import { usePage } from '@inertiajs/react';

const useInertiaData = () => {
    const { shared } = usePage<InertiaSharedData>().props;
    const { user, csrf_token, messages, is_impersonating, pending_billing_order, no_billing_order_record, account_paused, admin_permissions, static_pages, onboarding_resettable, enabled_integrations } = shared as InertiaSharedData;

    return { user, csrf_token, messages, is_impersonating, pending_billing_order, no_billing_order_record, account_paused, admin_permissions, static_pages, onboarding_resettable, enabled_integrations };
};

export default useInertiaData;
